import { auth } from "../firebase";
import ENV from "../env";
import i18n from "../i18n";

const ERROR_TRANSLATION_KEYS = {
  ADMIN_ROLE_REQUIRED: "error_admin_required",
  ADMIN_POS_REQUIRED: "error_pos_admin_required",
  ADMIN_TICKETING_REQUIRED: "error_ticketing_admin_required",
  ORGANIZATION_NOT_FOUND: "error_organization_not_found",
  TICKETING_NOT_FOUND: "error_ticketing_not_found",
  BUDGET_CATEGORY_NOT_FOUND: "error_category_not_found",
  BUDGET_CATEGORY_NAME_REQUIRED: "error_category_name_required",
  BUDGET_CATEGORY_DUPLICATE: "error_category_duplicate",
  BUDGET_CONSOLIDATION_ACTIVE: "error_consolidation_active",
  BUDGET_SYSTEM_CATEGORY_DELETE_FORBIDDEN: "error_system_category_delete",
  BUDGET_REQUEST_FAILED: "error_request_failed",
};

const getErrorMessage = (data) => {
  const translationKey = ERROR_TRANSLATION_KEYS[data?.code];
  if (translationKey) return i18n.t(translationKey, { ns: "budget", ...data?.details });
  return data?.message || i18n.t("error_request_failed", { ns: "budget" });
};

const request = async (path, options = {}) => {
  const token = await auth.currentUser?.getIdToken();
  if (!token) throw new Error("Authentication required");
  const response = await fetch(`${ENV.firebaseApiUrl}/budget${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...options.headers,
    },
  });
  if (response.status === 204) return null;
  const data = await response.json();
  if (!response.ok) {
    const error = new Error(getErrorMessage(data));
    error.code = data.code;
    throw error;
  }
  return data;
};

export const getBudgets = (ownerOrgId) =>
  request(`?ownerOrgId=${encodeURIComponent(ownerOrgId)}`);

export const getBudgetSources = (ownerOrgId) =>
  request(`/sources?ownerOrgId=${encodeURIComponent(ownerOrgId)}`);

export const createBudget = (payload) =>
  request("/", { method: "POST", body: JSON.stringify(payload) });

export const updateBudget = (budgetId, payload) =>
  request(`/${budgetId}`, { method: "PUT", body: JSON.stringify(payload) });

export const getBudgetDashboard = (budgetId) => request(`/${budgetId}/dashboard`);

export const createBudgetEntry = (budgetId, payload) =>
  request(`/${budgetId}/entries`, { method: "POST", body: JSON.stringify(payload) });

export const updateBudgetEntry = (budgetId, entryId, payload) =>
  request(`/${budgetId}/entries/${entryId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });

export const deleteBudgetEntry = (budgetId, entryId) =>
  request(`/${budgetId}/entries/${entryId}`, { method: "DELETE" });

export const createBudgetCategory = (budgetId, payload) =>
  request(`/${budgetId}/categories`, { method: "POST", body: JSON.stringify(payload) });

export const deleteBudgetCategory = (budgetId, categoryId) =>
  request(`/${budgetId}/categories/${encodeURIComponent(categoryId)}`, { method: "DELETE" });

export const rebuildBudgetRevenues = (budgetId, payload) =>
  request(`/${budgetId}/rebuild`, { method: "POST", body: JSON.stringify(payload) });
